import { render, staticRenderFns } from "./ProductUnit.vue?vue&type=template&id=33ca717c&scoped=true"
import script from "./ProductUnit.vue?vue&type=script&lang=ts"
export * from "./ProductUnit.vue?vue&type=script&lang=ts"
import style0 from "./ProductUnit.vue?vue&type=style&index=0&id=33ca717c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ca717c",
  null
  
)

export default component.exports